import axios from 'axios';

export const endpoints = {
    getUsers: companyId => `user/fromcompany/${companyId}`,
    loginAsUser: userId => `auth/admin/loginas/${userId}`,
    revokeAllAuthorizations: userId => `admin/revokeAllAuthorizations/${userId}`,
    unblockUser: userId => `admin/unblockUser/${userId}`,
    getUserActivities: userId => `usersactivity/userActivities/${userId}`,
    unlinkComrceOAuth: userId => `admin/unlinkComrceOAuth/${userId}`,

    getAllUsers: () => 'admin/allUsers/paged',
    getUserNotifications: () => `admin/userNotifications/paged`,
    createNotification: () => 'admin/userNotifications/create',
    resetNextReviewDateForUser: () => 'promoterScore/resetReviewDate',
    disableTwoFA: userId => `admin/disableTwoFA/${userId}`
};

export const getUsers = (companyId, params) =>
    axios.get(endpoints.getUsers(companyId), { params: { page: 1, count: 100, ...params } });
export const revokeAllAuthorizations = userId =>
    axios.post(endpoints.revokeAllAuthorizations(userId));
export const loginAsUser = userId => axios.post(endpoints.loginAsUser(userId));
export const unblockUser = userId => axios.post(endpoints.unblockUser(userId));
export const unlinkComrceOAuth = userId => axios.post(endpoints.unlinkComrceOAuth(userId));
export const disableTwoFA = userId => axios.post(endpoints.disableTwoFA(userId));
export const getUserActivities = (userId, params) =>
    axios.get(endpoints.getUserActivities(userId), { params: { page: 1, count: 10, ...params } });

export const getAllUsers = params =>
    axios.post(endpoints.getAllUsers(), { page: 1, count: 100, ...params });

export const getUserNotifications = (userId, params) =>
    axios.post(endpoints.getUserNotifications(), { page: 1, count: 10, ...params, userId });
export const createNotification = data => axios.post(endpoints.createNotification(), data);
export const resetNextReviewDateForUser = data =>
    axios.post(endpoints.resetNextReviewDateForUser(), data);
